import { useEffect, useState } from 'react';
import { KeyValueMap, convertDefects } from '../utils';
import { PaintBlocksCorrodedArea } from '@/__generated__/graphql';

interface DefectsChartsData {
  defectsByDeck: KeyValueMap[];
  defectsByPaintBlock: KeyValueMap[];
}

export const useDefectsGraphData = (
  defectsAreaForPaintBlockAndDecks: PaintBlocksCorrodedArea | undefined,
  selectedCoatingCondition: string[]
) => {
  const [chartsData, setChartsData] = useState<DefectsChartsData>({
    defectsByDeck: [],
    defectsByPaintBlock: [],
  });

  useEffect(() => {
    if (defectsAreaForPaintBlockAndDecks) {
      setChartsData({
        defectsByDeck: convertDefects(
          defectsAreaForPaintBlockAndDecks.defectsByDeck,
          selectedCoatingCondition
        ),
        defectsByPaintBlock: convertDefects(
          defectsAreaForPaintBlockAndDecks.defectsByPaintBlock,
          selectedCoatingCondition
        ),
      });
    }
  }, [defectsAreaForPaintBlockAndDecks, selectedCoatingCondition]);

  return {
    chartsData,
  };
};
